import * as VideoType from 'common/constants/video-type';
import * as AnalyticsVideoType from 'common/constants/analytics-video-type';
import { attempt } from 'lodash';


export const getAnalyticsVideoType = ({ type }) => {
    switch (type) {
        case VideoType.CLIP:
            return AnalyticsVideoType.CLIP;
        case VideoType.CLIPESODE:
            return AnalyticsVideoType.CLIPESODE;
        case VideoType.EPISODE:
            return AnalyticsVideoType.EPISODE;
        case VideoType.MARATHON:
            return AnalyticsVideoType.MARATHON;
        case VideoType.STREAM:
            return AnalyticsVideoType.STREAM;
        default:
            return AnalyticsVideoType.CLIP;
    }
};

export const sendVideoEvent = (type, data) => {
    return attempt(() => window.sendVideoEvent(type, data));
};

export const trackAlreadyLoggedInPage = (data) => {
    return attempt(() => window.trackAlreadyLoggedInPage(data));
};

export const trackAuthenticationComplete = (data) => {
    return attempt(() => window.trackAuthenticationComplete(data));
};

export const trackAuthenticationStart = (data) => {
    return attempt(() => window.trackAuthenticationStart(data));
};

export const trackNotLoggedInPage = (data) => {
    return attempt(() => window.trackNotLoggedInPage(data));
};

export const trackMetrics = (type, data) => {
    return attempt(() => window.trackMetrics({ type, data }));
};



// WEBPACK FOOTER //
// ./src/common/utils/analytics.js